import React, {useEffect, useState} from 'react';
import {FormHelperText, Button, Grid} from '@material-ui/core';
import {useHistory} from 'react-router-dom';
import Section from 'components/forms/Section';
import {Typography} from '@material-ui/core';
import {useFieldData} from 'components/forms/hooks';
import {flattenObj} from './SeaServiceDays';
import {sumValues} from './SeaServiceDays';
import fields from './fields';
import {AutoField} from 'components/forms/fields';
import Joi from 'joi';
import {useFormPersistence} from 'components/forms/hooks';
import {useContext} from 'react';
import FormState from '../context/FormState';
import {useFormContext} from 'react-hook-form';
import {Show} from 'components/utils/Show';

const SeaServiceTotals = ({generator, ...props}) => {
    const {node} = useContext(FormState);
    const {state, updateState} = useFormPersistence(node);
    const history = useHistory();
    const initialValues = {
        total_number_days: sumValues(
            flattenObj(state?.year_month_days_input_json)
        ),
        average_hours_underway: '',
        ave_dist_offshore: '',
    };
    const [data] = useFieldData('year_month_days_input_json');
    const [totalSSDays, setTotalSSDays] = useState();

    const schema = {
        total_number_days: Joi.number()
            .integer()
            .required()
            .min(1)
            .custom((value, helpers) => {
                if (
                    value !==
                    sumValues(flattenObj(state?.year_month_days_input_json))
                ) {
                    return helpers.error('any.invalid');
                }
                return value;
            })
            .messages({
                'any.invalid':
                    'The total number of days you entered in the box must be equal to the total of the days you entered in the monthly table on the previous page.',
            }),
        average_hours_underway: Joi.number()
            .integer()
            .required()
            .min(4)
            .max(24),
        ave_dist_offshore: Joi.number().integer().required().min(0),
    };

    useEffect(() => {
        if (Object.values(data).length > 0) {
            setTotalSSDays(sumValues(flattenObj(data)));
            if (generator) {
                updateState({
                    ...state,
                    total_number_days: sumValues(
                        flattenObj(state?.year_month_days_input_json)
                    ),
                    average_hours_underway: 4,
                });
            }
        } else {
            setTotalSSDays(0);
        }
        // eslint-disable-next-line
    }, [data]);

    const returnToUpload = () => {
        history.push(`/forms/cg719s/upload`);
    };

    const ReUploadButton = () => {
        const {errors} = useFormContext();

        if (errors?.total_number_days) {
        }
        return (
            <Show
                condition={
                    errors?.['total_number_days'] &&
                    (generator === 'false' || generator === false)
                }
            >
                <Grid style={{margin: '1em'}}>
                    <Typography color='secondary'>
                        If the total days on your hard copy form is incorrect,
                        you can update it by lining out the entry, writing the
                        correct value and then initialling next to it. Click the
                        button below, delete your old form image and add the
                        updated form. Then click next and double check
                        everything is still correct!
                    </Typography>
                    <Button
                        color='secondary'
                        variant='contained'
                        onClick={returnToUpload}
                    >
                        Upload New Image
                    </Button>
                </Grid>
            </Show>
        );
    };

    return (
        <Section
            {...props}
            {...{
                schema,
                initialValues,
            }}
            gridify
        >
            <Typography variant='h6' align='left'>
                Sea Service Totals
            </Typography>
            <Typography variant='body1' align='left'>
                Ok, now we'll collect some information about your sea service
                from the boxes at the bottom of form CG-719S.
            </Typography>
            <Typography variant='body1'>
                <b>Total Days Entered in Monthly Table: {totalSSDays}</b>
            </Typography>
            <ReUploadButton />
            <Show condition={!generator}>
                <AutoField
                    field={fields['total_number_days']}
                    name='total_number_days'
                    key='total_number_days'
                />
                <AutoField
                    field={fields['average_hours_underway']}
                    name='average_hours_underway'
                    key='average_hours_underway'
                />
            </Show>

            <AutoField
                field={fields['ave_dist_offshore']}
                name='ave_dist_offshore'
                key='ave_dist_offshore'
            />
            <FormHelperText>
                If over 200NM then NC days are counted as Oceans
            </FormHelperText>
            {props.children}
        </Section>
    );
};

export default SeaServiceTotals;
